import { render } from "./FormBooking.vue?vue&type=template&id=071cc4ac&scoped=true&bindings={\"theme\":\"props\",\"button\":\"props\",\"makeBooking\":\"options\"}"
import script from "./FormBooking.vue?vue&type=script&lang=js"
export * from "./FormBooking.vue?vue&type=script&lang=js"

import "./FormBooking.vue?vue&type=style&index=0&id=071cc4ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-071cc4ac"

export default script